import { render, staticRenderFns } from "./JiaoDingLiuShuiXianKanban.vue?vue&type=template&id=710d0410&"
import script from "./JiaoDingLiuShuiXianKanban.vue?vue&type=script&lang=js&"
export * from "./JiaoDingLiuShuiXianKanban.vue?vue&type=script&lang=js&"
import style0 from "./JiaoDingLiuShuiXianKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports